<div [@toggleBetslip]="showBetslip ? 'open' : 'closed'" class="display-wrapper">
  <app-betslip-header (closeBetslip)="onCloseBetslip()"></app-betslip-header>
  <div class="betslip-items">
    <div *ngFor="let Bet of Bets; index as i">
      <app-betslip-items class="display-body" [bet]="Bet" [betIndex]="i"></app-betslip-items>
    </div>
  </div>
  <app-betslip-action [Bets]="GetBets()"></app-betslip-action>
</div>
